import { CreateSourceWikipediaPhase } from "@/pages/sources/components/create/sources/wikipedia/types";

export enum CreateSourceWikipediaActionType {
  SET_SOURCE_NAME = "SET_SOURCE_NAME",
  SET_SEED_URL = "SET_SEED_URL",
  SET_LINKS_PER_PAGE = "SET_LINKS_PER_PAGE",
  SET_CRAWL_DEPTH = "SET_CRAWL_DEPTH",
  SET_MAX_PAGES = "SET_MAX_PAGES",
  SET_PHASE = "SET_PHASE",
  SET_ERROR = "SET_ERROR",
  SET_SHOULD_SHOW_ERRORS = "SET_SHOULD_SHOW_ERRORS",
}

export interface SetSourceNameAction {
  type: CreateSourceWikipediaActionType.SET_SOURCE_NAME;
  payload: string;
}

export interface SetSeedUrlAction {
  type: CreateSourceWikipediaActionType.SET_SEED_URL;
  payload: string;
}

export interface SetLinksPerPageAction {
  type: CreateSourceWikipediaActionType.SET_LINKS_PER_PAGE;
  payload: number;
}

export interface SetCrawlDepthAction {
  type: CreateSourceWikipediaActionType.SET_CRAWL_DEPTH;
  payload: number;
}

export interface SetMaxPagesAction {
  type: CreateSourceWikipediaActionType.SET_MAX_PAGES;
  payload: number;
}

export interface SetPhaseAction {
  type: CreateSourceWikipediaActionType.SET_PHASE;
  payload: CreateSourceWikipediaPhase;
}

export interface SetErrorAction {
  type: CreateSourceWikipediaActionType.SET_ERROR;
  payload: string | null;
}

export interface SetShouldShowErrorsAction {
  type: CreateSourceWikipediaActionType.SET_SHOULD_SHOW_ERRORS;
  payload: boolean;
}

export type CreateSourceWikipediaAction =
  | SetSourceNameAction
  | SetSeedUrlAction
  | SetLinksPerPageAction
  | SetCrawlDepthAction
  | SetMaxPagesAction
  | SetPhaseAction
  | SetErrorAction
  | SetShouldShowErrorsAction;
